var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMenuBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.49 19.74c.02.27-.11.45-.18.53-.08.09-.25.23-.53.23h-2.73l2.16-10.65h.69l.59 9.89zm.5-13.72c.02.24 0 .49-.06.74l-7.37 13.53A2.228 2.228 0 0 1 12.38 22h8.4a2.21 2.21 0 0 0 2.21-2.38L22 6l-.01.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9 1.331c-.4-.09-.81.15-.91.55l-.5 2.07h1.54l.42-1.71c.1-.4-.15-.81-.55-.91zM17.47 1.319a.75.75 0 0 0-.89.58l-.45 2.07h1.54l.38-1.76c.09-.41-.17-.8-.58-.89z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 3.961h-2.08l-.56 2.59c-.08.35-.39.59-.73.59-.05 0-.11 0-.16-.02a.765.765 0 0 1-.58-.89l.49-2.28h-5.1l-.63 2.6c-.08.34-.39.57-.73.57-.06 0-.12-.01-.18-.02a.75.75 0 0 1-.55-.91l.54-2.25H7.45c-.98 0-1.85.64-2.14 1.58L1.1 19.071c-.44 1.45.63 2.93 2.14 2.93h13.14c1.04 0 1.94-.7 2.18-1.71l3.37-13.53c.06-.25.08-.5.06-.74a2 2 0 0 0-.17-.69c-.33-.8-1.11-1.37-2.07-1.37zM6.7 16.751c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75h-8zm1-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75h-8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMenuBoard);
export default __webpack_public_path__ + "static/media/vuesax-bold-menu-board.0da4395ed27d26ae63a512d3ed4b29d6.svg";
export { ForwardRef as ReactComponent };